<ion-header>
  <ion-toolbar color="primary" class="modal">
    <ion-buttons slot="end">
      <ion-button class="disable-default-style" (click)="modalController.dismiss()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
